import React, {useEffect, useRef, useState} from "react";
import {IonInputPasswordToggle} from "@ionic/react";
import InputFIE, {IFormInputProps} from "./InputFIE";


const PasswordInputFIE = (props: IFormInputProps) =>
{
    let {
        children,
        elementProps,
        ...formInputProps
    } = props;

    const useElementProps = elementProps ?? {};
    useElementProps.type = "password";
    const passwordToggleRef = useRef<HTMLIonInputPasswordToggleElement|null>(null);
    const [didApplyShadowRoot, setDidApplyShadowRoot] = useState<boolean>(false);

    if(!didApplyShadowRoot){
        const buttonShadowRoot = passwordToggleRef.current?.shadowRoot?.children[0]?.shadowRoot ?? null;
        if(buttonShadowRoot){
            let rulesCSSText = ':host(.button-has-icon-only) {background: #000;border-radius: 0;color: white;font-weight: 100;}';
            const sheet = new CSSStyleSheet();
            sheet.replaceSync(rulesCSSText);
            buttonShadowRoot.adoptedStyleSheets.push(sheet);
            setDidApplyShadowRoot(true);
        }
    }

    return <InputFIE
        {...formInputProps}
        elementProps={useElementProps}
    >
        <>
            {children}
            <IonInputPasswordToggle
                slot="end"
                ref={passwordToggleRef}

            />
        </>
    </InputFIE>;
}

export default PasswordInputFIE;